<script setup lang="ts">
import StarIcon from '@/components/icons/starIcon.vue'
import { computed } from 'vue'

interface Props {
    rating: number
    interactive?: boolean
    showValue?: boolean
    size?: 'small' | 'medium' | 'large'
    isCreate?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    interactive: false,
    showValue: false,
    size: 'large',
    isCreate: false,
})
const emit = defineEmits<{
    change: [rating: number]
}>()
const handleClick = (star: number) => {
    if (props.interactive) {
        emit('change', star)
    }
}
const isDisabledColors = computed(() => {
    return !props.isCreate && props.rating === 0
})
</script>

<template>
    <div
        class="stars"
        :class="{
            stars_norating: isDisabledColors,
            stars_interactive: interactive,
            stars_small: size === 'small',
            stars_medium: size === 'medium',
            stars_large: size === 'large',
        }"
    >
        <div
            v-for="star in 5"
            :key="star"
            class="stars__item"
            :class="{
                stars__item_active: star <= Math.round(rating),
            }"
            :disabled="!interactive"
            @click="handleClick(star)"
        >
            <StarIcon :fill="isDisabledColors ? 'var(--app-disabled-bg)' : ''" />
        </div>
    </div>
    <div v-if="showValue" class="rating-value">
        {{ rating.toFixed(1) }}
    </div>
</template>

<style lang="stylus">
.stars
    display flex
    align-items center
    pointer-events none
    &_interactive
        pointer-events all
    &__item
        opacity 0.5
        &_active
            opacity 1
        ^[0]_large &
            width 48px
            height 48px
        ^[0]_medium &
            width 20px
            height 20px
        ^[0]_small &
            width 15px
            height 15px
        ^[0]_norating & svg
            fill var(--app-disabled-bg)
</style>
